var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aspenware--cross-sell-minicart-view"}},[_c('portal',{attrs:{"to":"minicart-bottom-end"}},[(_vm.eventTimestamp)?_c('CrossSellMiniCart',{key:_vm.eventTimestamp,attrs:{"title":_vm.title}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }